import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { inject, observer } from 'mobx-react'

import { STATES } from '~/utilities/constants'

import LabeledSimpleInput from '~/components/Form/LabeledSimpleInput'
import LabeledSimpleDropdown from '~/components/Form/LabeledSimpleDropdown'

@inject(all => ({
  // user: all.store.auth.user,
  isLoading: all.store.payment.isLoading,
  addressChange: all.store.payment.addressChange
}))
@observer
class FormItemComponent extends Component {
  handleChange = key => event => {
    const { addressChange } = this.props
    const { value } = event.target // eslint-disable-line
    
    addressChange.changeKey(key, value)
  }

  render() {
    const {
      id,
      addressChange,
      isLoading,
      targetKey,
      label,
      placeholder,
      stateSelector
    } = this.props
    const fieldError = addressChange.validateDisplayMessage(targetKey)
    const currentValue = addressChange[targetKey]
    let FormComponent = (
      <LabeledSimpleInput
        id={id}
        label={label}
        placeholder={placeholder}
        disabled={isLoading}
        onChange={this.handleChange(targetKey)}
        value={currentValue || ''}
        error={fieldError}
      />
    )
    if (stateSelector) {
      // Some users have full state name for `countryState`
      // This is meant to convert those full state names into short codes
      let safeCurrentValue = null
      if (currentValue && STATES[currentValue]) {
        // if state is valid 2 char state code: NY/NJ/CA/CT
        safeCurrentValue = currentValue
      } else if (currentValue) {
        // if we do not have a valid 2 char state but do have a current state
        const cleanCurrentValue = currentValue.trim().toLowerCase()
        const stateLookUpObject = {}
        Object.keys(STATES).forEach(stateShortName => {
          const stateFullName = STATES[stateShortName].toLowerCase()
          stateLookUpObject[stateFullName] = stateShortName
        })
        if (stateLookUpObject[cleanCurrentValue]) {
          safeCurrentValue = stateLookUpObject[cleanCurrentValue]
        }
        // otherwise we use null and pretend we dont have a state.
      }
      const selectedState = safeCurrentValue
        ? {
            value: safeCurrentValue,
            label: STATES[safeCurrentValue]
          }
        : null
      FormComponent = (
        <LabeledSimpleDropdown
          autoComplete="on"
          id={id}
          label={label}
          disabled={isLoading}
          placeholder={placeholder}
          onChange={this.handleChange(targetKey)}
          value={selectedState}
          error={fieldError}
          options={Object.keys(STATES).map((stateShortName) => ({
            value: stateShortName,
            label: STATES[stateShortName],
          }))}
        />
      )
    }
    return FormComponent
  }
}

FormItemComponent.defaultProps = {
  isLoading: false,
  stateSelector: false
}

FormItemComponent.propTypes = {
  stateSelector: PropTypes.bool,
  isLoading: PropTypes.bool,
  label: PropTypes.string.isRequired,
  targetKey: PropTypes.string.isRequired
}

export default FormItemComponent
